import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutModule } from 'app/layout/layouts/empty/empty.module';
import { NavigatorModule } from "./layouts/navigator/navigator.module";
import { RedirectComponent } from './layouts/redirect/redirect.component';
import { NgIf } from "@angular/common";

const layoutModules = [
    // Empty
    EmptyLayoutModule,
    NavigatorModule
];

@NgModule({
    declarations: [LayoutComponent, RedirectComponent],
    imports: [...layoutModules, NgIf],
    exports: [LayoutComponent, RedirectComponent, ...layoutModules],
})
export class LayoutModule {
}
